const alphabet = "abcdefghijklmnopqrstuvwxyz0123456789";
export function createBoundary() {
    let size = 16;
    let res = "";
    while (size--) {
        res += alphabet[(Math.random() * alphabet.length) << 0];
    }
    return res;
}
